import apis from '@/apis/index.js'
import msg from '@/utils/msg.js'
import timeLite from './helpers/timeLite.js'
import { getStorage, setStorage } from '@/utils/helpers/storage'
const getCouponList = async function (obj) {
  let result = await apis.application.queryCouponList({ status: 1, pageSize: 300 }).then(res => {
    if (res.httpCode == 200 && res.data) {
      return {
        data: res.data.list || []
      }
    } else {
      msg.error(res.msg)
    }
  })
  return result
}
const getCouponIds = function (cplist) {
  let couponIds = []
  let numbers = []
  let couponIdsStr = ''
  let numbersStr = ''
  let obj = {}
  if (cplist) {
    cplist.forEach(item => {
      if (item.couponId != '' && item.number != '') {
        couponIds.push(item.couponId)
        numbers.push(item.number)
      }
    })
    if (couponIds.length > 0) {
      couponIdsStr = couponIds.join(',')
      numbersStr = numbers.join(',')
    }
    obj.couponIds = couponIdsStr
    obj.numbers = numbersStr
  }
  return obj
}
//设置初始查询时间段
const InitialDays = function (start = 7, end = 0) {
  let data = new Date()
  var time1
  if (end) {
    time1 = timeLite.format(data.getTime() + end * 24 * 60 * 60000, 'YYYY-MM-DD') + ' 23:59:59'
  } else {
    time1 = timeLite.format(data, 'YYYY-MM-DD') + ' 23:59:59'
  }
  var time2 = timeLite.format(data.getTime() - start * 24 * 60 * 60000, 'YYYY-MM-DD') + ' 00:00:00'
  return [time2, time1]
}
//校验输入框长度
const validateLength = (rule, value, callback) => {
  if (value.length > 20) {
    callback(new Error('最多输入20个字符'))
  } else {
    callback()
  }
}
//校验输入框长度(兼容中英文)
const codeValidateLength = (srt, length) => {
  let a = 0, content, newSrt = ''
  content = srt
  for (let i = 0; i < content.length; i++){
    let str = content[i].charCodeAt()
    a += str > 0 && str < 255 ? 1 : 3
    if (a <= length) newSrt += content[i].charAt()
  }
  return newSrt
}
//所有可用支付方式
const queryPayTypeList = async function () {
  let recoredPayList = [
    { id: 1, value: '1', name: '微信', isElse: false },
    { id: 2, value: '2', name: '支付宝', isElse: false },
    // { id:3,value:'3',name:'其它',isElse:false},
    { id: 4, value: '4', name: '优卡支付', isElse: false },
    { id: 7, value: '7', name: '现金', isElse: false },
    // { id:5,value:'5',name:'通付卡支付',isElse:false},
    { id: 6, value: '6', name: '组合支付', isElse: false }
  ]
  let result = await apis.setting.queryOtherList().then(res => {
    if (res.httpCode == 200 && res.data) {
      let data = res.data || []
      let dataList = data.filter(item => {
        return item.status == 1
      })
      if (dataList.length > 0) {
        dataList.forEach(item => {
          item.value = 3
          item.isElse = true
        })
        let initPayList = JSON.parse(JSON.stringify(recoredPayList))
        return initPayList.concat(dataList)
      }
    } else {
      msg.error(res.msg)
    }
  })
  return result
}
//所有支付方式
const queryAllPayTypeList = async function () {
  let recoredPayList = [
    { id: 1, value: '1', name: '微信', isElse: false },
    { id: 2, value: '2', name: '支付宝', isElse: false },
    // { id:3,value:'3',name:'其它',isElse:false},
    { id: 4, value: '4', name: '优卡支付', isElse: false },
    { id: 7, value: '7', name: '现金', isElse: false },
    // { id:5,value:'5',name:'通付卡支付',isElse:false},
    { id: 6, value: '6', name: '组合支付', isElse: false }
  ]
  let initPayList = JSON.parse(JSON.stringify(recoredPayList))
  let result = await apis.setting.queryOtherList().then(res => {
    if (res.httpCode == 200 && res.data) {
      let dataList = res.data || []
      if (dataList.length > 0) {
        dataList.forEach(item => {
          item.value = 3
          item.isElse = true
        })
        return initPayList.concat(dataList)
      } else {
        return initPayList
      }
    } else {
      return initPayList
    }
  })
  return result
}
//查询商家所有店铺列表
const getStoreList = async function () {
  let result = []
  result = await apis.takeout.queryStoreInfoTabList().then(res => {
    const options = res.data.map(item => {
      return {
        id: item.id || '',
        name: item.branchName || '',
        ...item
      }
    })
    setStorage('storeList', options || [])
    return options
  })
  return result
}
//查询所有订单类型
const getOrderTypeList = async function () {
  let result = []
  result = await apis.takeout.queryAllOrderTypeList().then(res => {
    const options = []
    let datalist = res.data.list || []
    if (datalist.length > 0) {
      datalist.forEach((item) => {
        const obj = {
          id: item.id || '',
          name: item.typeName || ''
        }
        options.push(obj)
      })
    }
    return options
  })
  return result
}
const getQyUserList = async function () {
  let result = []
  result = await apis.workWx.queryQyUserList({}).then(res => {
    if (res.httpCode == 200 && res.data) {
       const options = []
       let datalist = res.data.list || []
       if (datalist.length > 0) {
         datalist.forEach(item => {
           const obj = {
             id: item.userid || '',
             name: item.name || ''
           }
           options.push(obj)
         })
         setStorage('qyUserList', options || [])
       }
       return options
    } else {
      this.$msg.error(res.msg)
    }
  })
  return result
}
//新建营销活动，时间检查方法
const actCheckTime = async function (e, effDate, expDate) {
  let result = true
  let d = new Date(e[0])
  let d1 = d.getTime(d)
  let d2 = ''
  let dd = ''
  if (e && effDate && expDate) {
    if (e[1] == 1) {
      dd = new Date(effDate)
      d2 = dd.getTime(dd)
      if (d1 < d2) {
        msg.error('结束日期不能小于开始日期')
        result = false
      }
    } else {
      dd = new Date(expDate)
      d2 = dd.getTime(dd)
      if (d1 > d2) {
        msg.error('开始日期不能大于结束日期')
        result = false
      }
    }
  }
  return result
}
//设置服务时间
const setTimePlan = function (callback) {
  apis.setting.planList().then(res => {
    if (res.httpCode == 200 && res.data) {
      setStorage('timePlanData', res.data.list || null)
      callback && callback()
    } else {
      this.$msg.error(res.msg)
    }
  })
}

//除法函数，用来得到精确的除法结果
//调用：division(arg1,arg2)
//返回值：arg1除以arg2的精确结果
function division(arg1, arg2) {
	var t1 = 0,
		t2 = 0,
		r1,
		r2;
	try {
		t1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		t1 = 0;
	}
	try {
		t2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		t2 = 0;
	}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	return multiplication(r1 / r2, Math.pow(10, t2 - t1));
}

//乘法函数，用来得到精确的乘法结果
//调用：multiplication(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
function multiplication(arg1, arg2) {
	var m = 0,
		s1 = arg1.toString(),
		s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length;
	} catch (e) {
		m = 0;
	}
	try {
		m += s2.split(".")[1].length;
	} catch (e) {
		m = m || 0;
	}
	return (
		(Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m)
	);
}

//加法函数，用来得到精确的加法结果
//调用：addition(arg1,arg2)
//返回值：arg1加上arg2的精确结果
function addition(arg1, arg2) {
	var r1, r2, m, n;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	n = r1 >= r2 ? r1 : r2;
	return ((arg1 * m + arg2 * m) / m).toFixed(n);
}

//减法函数，用来得到精确的减法结果
//调用：subtraction(arg1,arg2)
//返回值：arg1减去arg2的精确结果
function subtraction(arg1, arg2) {
	var r1, r2, m, n;
	try {
		r1 = arg1.toString().split(".")[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split(".")[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	//动态控制精度长度
	n = r1 >= r2 ? r1 : r2;
	return ((arg1 * m - arg2 * m) / m).toFixed(n);
}


export default {
  getCouponList,
  getCouponIds,
  InitialDays,
  queryPayTypeList,
  queryAllPayTypeList,
  getStoreList,
  getOrderTypeList,
  getQyUserList,
  actCheckTime,
  setTimePlan,
  validateLength,
  codeValidateLength,
  division,
  multiplication,
  addition,
  subtraction
}
